import MapBuilder from './MapBuilder';

const fetch = require('node-fetch');

export default {
  settings: {
    lineColor: '#593622',
    lineColorHighlight: '#f2c730',
    lineOpacity: 0.7,
    highlightOpacity: 1,
    connectorLinColor: '#8A898C',
    routeLineColor: '#0537CC'
  },

  createMap() {
    window.mapboxgl.accessToken = 'pk.eyJ1IjoiZGFucnVzcyIsImEiOiJjampwbXNmYWUwMjZ0M3ZwbjJpd3d0bHEzIn0.greAVknu-Kp7qrqAimYBlw';
    let map = new window.mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/outdoors-v11'
    });

    // zoom controls
    map.addControl(new window.mapboxgl.NavigationControl(),'top-right');
    
    // geolocation control
    // TODO: automate this so pin is present at load time
    map.addControl(new window.mapboxgl.GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true
      },
      trackUserLocation: true
    }));

    return map;
  },

  // converts an array of coordinates into usable map bounds
  generateMapBounds(coordinates) {
    return coordinates.reduce(function(bounds, coord) {
      return bounds.extend(coord);
    }, new window.mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));
  },

  getMapBounds(geoJson) {
    let coordinates = [];
    
    console.log(geoJson);
    // some objects are made up of multiple parts
    if (geoJson.features) {
        geoJson.features.forEach((feature) => {
          coordinates = coordinates.concat(feature.geometry.coordinates);
        });
    } else {
      // for some reason the coords array is wrapped with an extra array when there are no features
      coordinates = geoJson.geometry.coordinates[0];
    }

    return this.generateMapBounds(coordinates);
  },

  getMapBoundsFromMany(geoJsonList) {
    let coordinates = [];

    geoJsonList.forEach((road) => {
      // some objects are made up of multiple parts
      road.features.forEach((feature) => {
        coordinates = coordinates.concat(feature.geometry.coordinates);
      });
    })

    return this.generateMapBounds(coordinates);
  },

  highlightRoad(map, road, highlight) {
    if (map && map.getLayer(road.name)) {
      let isConnector = MapBuilder.isRoadConnector(road);

      if(highlight) {
        map.setPaintProperty(road.name, 'line-color', this.settings.lineColorHighlight);

        if (!isConnector) {
            map.setPaintProperty(road.name, 'line-opacity', this.settings.highlightOpacity);
        }
      } else {
        let color = isConnector ? this.settings.connectorLinColor : this.settings.lineColor;

        map.setPaintProperty(road.name, 'line-color', color);

        if (!isConnector) {
            map.setPaintProperty(road.name, 'line-opacity', this.settings.lineOpacity);
        }
      }
    }
  },

  async getDirections (coords){
    let requestUrl = 'https://api.mapbox.com/directions/v5/mapbox/driving/';
    
    coords.forEach((coord, index) => {
      requestUrl += coord.join();

      if(index < coords.length-1) {
        requestUrl += ';'
      }
    });

    requestUrl += `?access_token=${window.mapboxgl.accessToken}&geometries=geojson`;

    try {
      const response = await fetch(requestUrl);
      const json = await response.json();
      return json;
    } catch (error) {
      console.log(error);
    }

    return;
  }
}